import { InputBase } from '@mui/material'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as SearchIcon } from '../../assets/images/icons/search.svg'
import { ROUTES } from '../../utils/constants/enum'
import styles from './search-bar.module.scss'

interface ISearchBarInterface {
    callback?: (value: boolean) => void
}

const SearchBar: React.FC<ISearchBarInterface> = ({ callback }) => {
    const [searchText, setSearchText] = useState<string>('')

    const navigate = useNavigate()

    const handleSearchSubmit = useCallback(
        (e: any) => {
            e.preventDefault()
            if (!searchText) {
                return
            }
            navigate({
                pathname: ROUTES.SEARCH,
                search: `?query=${searchText}&page=0`,
            })

            if (callback) {
                callback(false)
            }
        },
        [callback, searchText, navigate]
    )

    const handleSearchChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setSearchText(e.target.value)
        },
        []
    )

    return (
        <div className={styles['search-box']}>
            <form onSubmit={handleSearchSubmit}>
                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search"
                    inputProps={{ 'aria-label': 'search google maps' }}
                    onChange={handleSearchChange}
                    value={searchText}
                    startAdornment={
                        <SearchIcon
                            className={styles['search-icon']}
                            onClick={handleSearchSubmit}
                        />
                    }
                    fullWidth
                    className={styles['input-base']}
                />
            </form>
        </div>
    )
}

export default SearchBar
